import BlendedSectorWeightings from "@/components/benchmark/BlendedSectorWeightings";
import { DIST_PORTFOLIOS, distLabel } from "./distConfig";

export default function DistSectorWeightings() {
  return (
    <BlendedSectorWeightings
      side="dist"
      portfolios={DIST_PORTFOLIOS}
      title="Dist Sector Weightings"
      portfolioLabel={distLabel}
    />
  );
}
